var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.buttons),function(button){return _c(button.component,_vm._g(_vm._b({key:button.key,tag:"component",staticClass:"topbar__button"},'component',button.binding,false),button.events),[_vm._v(_vm._s(button.text))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }